module.exports = __webpack_public_path__ + "fonts/montserrat-extrabolditalic-webfont.4ae7169.woff2";